module.exports = __webpack_public_path__ + "img/corrugatedBox7.acde8596.jpg";